import React from 'react';

var SvgSearchMajor = function SvgSearchMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 8c0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6-6-2.691-6-6zm17.707 10.293-5.395-5.396a7.946 7.946 0 0 0 1.688-4.897c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8a7.954 7.954 0 0 0 4.897-1.688l5.396 5.395a.998.998 0 0 0 1.707-.707 1 1 0 0 0-.293-.707z"
  }));
};

export { SvgSearchMajor as S };
